angular.module('app').directive('autoBrandComplete', [
    () => {
      let link = (scope) => {
        scope.isVisible = {
          suggestions: false,
        };
  
        // dummy data
        scope.categories = [
          "A-C", "D-F", "G-I", "J-L", "M-O", "P-R", "S-U", "V-Z"
        ];  
  
        scope.categoriesData = [
          ['a', 'b', 'c'],
          ['d', 'e', 'f'],
          ['g', 'h', 'i'],
          ['j', 'k', 'l'],
          ['m', 'n', 'o'],
          ['p', 'q', 'r'],
          ['s', 't', 'u'],
          ['v', 'w', 'x', 'y', 'z']
        ];
         
        scope.filteredChoices = scope.brands;
        scope.isVisible = {
          suggestions: false,
        }; 
  
        scope.selectedCategoryIndex = 0;
        scope.categorySelect = index => { 
          scope.selectedCategoryIndex = index;
          scope.enteredtext = scope.categories[index].toLowerCase().substr(0, 1);
          scope.searchTitle();
        };
  
        scope.searchTitle = () => {
          if (scope.enteredtext.length < 0) {
            return;
          }
          scope.searchhandler('carBrand', scope.enteredtext, 1);
        };
  
        scope.filterItemsByCategory = () => {
          if (!scope.enteredtext.length) {
            scope.isVisible.suggestions = false;
            return;
          }
          scope.isVisible.suggestions = true;
  
          scope.selectedCategoryIndex = scope.categoriesData.findIndex(cat => cat.includes(scope.enteredtext.toLowerCase().substr(0, 1)));
  
          scope.filteredChoices = scope.filteredChoices.filter(attrib => {
            return scope.categoriesData[scope.selectedCategoryIndex].includes(attrib.title.toLowerCase().substr(0, 1));
          });
          scope.filteredChoices = scope.filteredChoices.filter((item, index, self) =>
            index === self.findIndex((t) => (
              t.id === item.id
            ))
          )
        };
  
        scope.filterItems = () => {  
          if (!scope.enteredtext.length) {
            scope.isVisible.suggestions = false;
            return;
          }
          scope.isVisible.suggestions = true;
          scope.filteredChoices = scope.brands.filter(attr => { 
            let search = scope.enteredtext.toLowerCase();
            let title = attr.title.toLowerCase();
            return title.startsWith(search.substr(0, 1)) && title.includes(search);
          }); 
          scope.selectedCategoryIndex = scope.categoriesData.findIndex(cat => cat.includes(scope.enteredtext.substr(0, 1))); 
          scope.filterItemsByCategory();
        }; 
  
        scope.selectItem = (choice) => { 
          scope.selected = choice;
          scope.enteredtext = choice.title;
          scope.isVisible.suggestions = false;
          scope.selecthandle(scope.selecttype, choice);
        };
  
        scope.$watch('brands', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.brands = newValue;
            scope.filterItems();
          }
        }, true);
  
        scope.viewMore = ()=> { 
          scope.searchhandler('carBrand', scope.enteredtext, 1);
        }
  
      };
  
      return {
        restrict: "E",
        templateUrl: "app/directives/dbAutoBrandComplete/dbAutoBrandCompleteView.html",
        link: link,
        scope: {
          enteredtext: "=",
          selected: "=",
          placeholder: "=",
          selecthandle: "=",
          selecttype: "=",
          disabled: "=",
          disable: "=",
          brands:"=",
          board: "=",
          searchhandler: "=",
        }
      };
    }
]);